module.exports = __webpack_public_path__ + "static/media/load.5d419292.gif";